export const OPTOUTGET = "OPTOUT.GET";